








import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import ReviewLayout from '@/UI/UserProcedures/BidProcedures/Review/ReviewLayout.vue'

const accountStore = namespace('account')

@Component({
  components: {
    ReviewLayout
  }
})
export default class Review extends Vue {
  @accountStore.Getter
  public accountId!: string

  public continuar = false

  get procedureId (): string {
    return this.$route.params.procedureId
  }
}
